import { BaseModel, convertToModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'
import LandingBannerButton from './LandingBannerButton'

export default class LandingMainBannerBlock extends BaseModel {
  static override constructorName = 'LandingMainBannerBlock'

  readonly name = 'main_banner_block'

  title: string = ''
  text: string = ''
  logo: string = ''
  'background_image': string = ''
  button: LandingBannerButton = new LandingBannerButton()

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['logo', 'background_image', 'button'])

      this.logo = toCroppedImage(data.logo)
      this.background_image = toCroppedImage(data.background_image)
      this.button = convertToModel(data.button, LandingBannerButton, new LandingBannerButton())
    }
  }
}
